import { ImageSetBet } from "@/bet-nextv1/ImageSetBet";
import withHeader from "@/bet-nextv1/utils/withHeader";
import { LoadingPage } from "@/component-nextv3/LoadingPage";
import {
	collectionDocument,
	getDocument,
} from "@/core-nextv3/document/document.api";
import { calls, revalidateResults } from "@/core-nextv3/util/call.api";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import {
	AUTH_SETTING,
	EVENT_SETTING,
	HOME_PAGE_SETTING,
	REVALIDATE_SETTING,
} from "@/setting/setting";
import type { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { ModalEvent } from "../../ModalEvent";
import { useProtectedAuthMeta } from "../../context/useProtectedAuthMeta";
import styles from "./styles.module.scss";

export default function EventPage({ events, banners }: any) {
	const router = useRouter();
	const [selectedEvent, setSelectedEvent] = useState<any>(
		events?.find((event: any) => event.id === router.query.selectedId),
	);
	const [openModal, setOpenMdoal] = useState(!!selectedEvent);
	const { isClient } = useResponsive();

	const resp = useResponsive();

	useEffect(() => {
		if (router.query.selectedId) {
			const event = events?.find(
				(event: any) => event.id === router.query.selectedId,
			);

			if (event) {
				setSelectedEvent(event);
				setOpenMdoal(true);
			}
		}
	}, [router.query.selectedId]);

	const handleClick = (event: any) => {
		setOpenMdoal(true);
		setSelectedEvent(event);
	};

	const loadProtectedAuth = useProtectedAuthMeta(AUTH_SETTING, "", "/");

	if (!loadProtectedAuth) {
		return <LoadingPage />;
	}

	if (!isClient) {
		return <></>;
	}

	return (
		<>
			<div className={styles.event}>
				{banners && banners?.length > 0 && (
					<ImageSetBet
						src={
							resp?.isDesktop
								? banners?.[0]?.desktop?._url || ""
								: banners?.[0]?.mobile?._url || ""
						}
					/>
				)}
				<div className={styles.content}>
					<div className={styles.cardsEvent}>
						{events?.map((event: any, key: any) => (
							<div
								className={styles.promoItems}
								key={key}
								onClick={() => handleClick(event)}
							>
								<div className={styles.promoThumb}>
									<ImageSetBet
										src={event?.bannerImage?._url}
										alt="bannerImage"
									/>
								</div>

								<div className={styles.promoContent}>
									<h3>Event {key + 1}</h3>
									<h2>{event?.title}</h2>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			{openModal && <ModalEvent close={setOpenMdoal} event={selectedEvent} />}
		</>
	);
}

export const getStaticProps: GetStaticProps = ({ locale }) =>
	withHeader(async (_props: any) => {
		const [events, home] = await calls(
			collectionDocument(EVENT_SETTING.merge({ perPage: 100 })),
			getDocument(HOME_PAGE_SETTING),
		);

		const result = revalidateResults([events, home]);

		if (result.revalidate) {
			return result;
		}

		return {
			props: {
				locale: locale,
				events: events?.collection || [],
				banners: home?.data?.event || [],
			},
			revalidate: REVALIDATE_SETTING,
		};
	});

export { getStaticProps as GetStaticProps, EventPage };
